/**
 * Countdown for genuinely time-limited offers.
 *
 * The end time is an ABSOLUTE timestamp rendered into the markup by Liquid, so
 * every instance of the same offer — product page, cart, a second tab — counts
 * to the same instant, and a reload does not restart anything. There is no
 * "now + N hours" path anywhere in this file.
 *
 * One interval drives every timer on the page rather than one each.
 *
 * At zero it stops, hides the message, and dispatches calmy:offer:expired so
 * the page can refresh the affected prices. It does not decide anything about
 * eligibility — the commerce system enforces the expiry; this only stops
 * showing a promise that has run out.
 */
(function () {
  "use strict";
  if (window.__calmyCountdown) return;
  window.__calmyCountdown = true;

  var tick = null;

  function two(n) { return n < 10 ? "0" + n : String(n); }

  function render(el, endMs, now) {
    var left = endMs - now;
    if (left <= 0) {
      el.__calmyDone = true;
      /* A styling hook for the expired state. Presentation only: nothing here
         or anywhere below disables a control or blocks a purchase. */
      el.classList.add("is-expired");
      /* Expired wording if the merchant supplied any, otherwise the line goes.
         Either way the timer stops and the page is asked to refresh prices —
         what a customer may actually still buy is the commerce system's
         decision, not this file's. */
      var msg = el.getAttribute("data-expired");
      if (msg) {
        var lab = el.querySelector(".ccd__l");
        var tm = el.querySelector("[data-calmy-countdown-time]");
        if (lab) lab.textContent = msg;
        if (tm) tm.remove();
      } else {
        el.hidden = true;
      }
      document.dispatchEvent(new CustomEvent("calmy:offer:expired", {
        detail: { ends: el.getAttribute("data-ends") }, bubbles: true
      }));
      return false;
    }
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    var out = el.querySelector("[data-calmy-countdown-time]");
    if (out) {
      /* data-format="ms" is for a SHORT deal, where "00:14:59" says the wrong
         thing about its own length: under an hour it reads MM:SS. Past an hour
         it falls back to the full form on its own rather than counting 90
         minutes as "90:00", so a long deadline is still stated correctly. */
      if (el.getAttribute("data-format") === "ms" && d === 0 && h === 0) {
        out.textContent = two(m) + ":" + two(s);
      } else {
        /* Days only once there are days — "00:23:59:59" reads as a bug. */
        out.textContent = (d > 0 ? d + "d " : "") + two(h) + ":" + two(m) + ":" + two(s);
      }
    }
    return true;
  }

  function all() { return [].slice.call(document.querySelectorAll("[data-calmy-countdown]")); }

  function run() {
    var now = Date.now();
    var live = 0;
    all().forEach(function (el) {
      if (el.__calmyDone) return;
      var endMs = el.__calmyEnd;
      if (endMs === undefined) {
        endMs = Date.parse(el.getAttribute("data-ends") || "");
        /* An unparseable date is not a reason to invent one. */
        if (isNaN(endMs)) { el.hidden = true; el.__calmyDone = true; return; }
        el.__calmyEnd = endMs;
      }
      if (render(el, endMs, now)) live++;
    });
    if (!live && tick) { window.clearInterval(tick); tick = null; }
  }

  function boot() {
    if (!all().length) return;
    run();
    if (!tick) tick = window.setInterval(run, 1000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  /* One interval, rebound rather than duplicated, after an editor reload. */
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("visibilitychange", function () { if (!document.hidden) run(); });
})();
